import React, { useState } from 'react';
import { loginUser } from '../api/api';
import '../css/style.css';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: ''});

  //toggle eye
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [error, setError] = useState('');

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.id]: e.target.value
    }));
  };

  const handleLogin = async (e) => {
  e.preventDefault(); 
  try {
    const result = await loginUser(formData);
    console.log('Login successful:', result.data);
    alert('Login successful'); 

    //clear input fields
    setFormData({  email: '', password: ''});

    navigate('/customer');

    localStorage.setItem('token', result.data.token); 

    // navigate to another page if needed
  } catch (err) {
    console.error('Login error:', err.response?.data || err.message);
    setError('Login failed. Please try again.');
  }
};

  return (
    <div className="page-container">
      <div className="login-container">
        <h2 className="login-title">Login</h2>
        <form className="login-form" onSubmit={handleLogin}>
         
         <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            placeholder="Enter your email"
            autoComplete="new-email"
            value={formData.email}
            onChange={handleChange}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault(); // prevent form submission
                document.getElementById("password").focus(); // move focus to password
              }
            }}
          />
        </div>


          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="pass-group">
              <input
                id="password"
                type={isPasswordVisible ? "text" : "password"}
                placeholder="Enter your password"
                autoComplete="new-password"
                value={formData.password}
                onChange={handleChange}
                className="pass-input"
              />
              <span
                className="toggle-password"
                onClick={() => setPasswordVisible(prev => !prev)}
              >
                {/* Eye icon */}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M12 5C7 5 2.73 8.11 1 12c1.73 3.89 6 7 11 7s9.27-3.11 11-7c-1.73-3.89-6-7-11-7zm0 12a5 5 0 110-10 5 5 0 010 10zm0-8a3 3 0 100 6 3 3 0 000-6z"/>
                </svg>

                {/* Horizontal line over eye when password hidden */}
                {!isPasswordVisible && <span className="eye-line"></span>}
              </span>
            </div>
          </div>
          
          {error && <p style={{ color: 'red' }}>{error}</p>}

          <button type="submit">Login</button>
        </form>
      </div>
    </div>
  );
};

export default Login;

